<template>
    <div class="schedule-detail-box">
        <el-dialog title="日程安排" :visible.sync="dialogVisible" width="680px" @close="handleClose">
            <div class="descri">
                <span>日程时间</span>
                {{ scDetail.docStartTime }} - {{ scDetail.docFinishTime }}
            </div>
            <div class="descri">
                <span>日程概要</span>
                <p>{{ scDetail.docSubject ? scDetail.docSubject : "********" }}</p>
            </div>
            <div class="person-box">
                <div class="creator">
                    <img :src="scDetail.docOwner ? scDetail.docOwner.avatar : ''" alt />
                    <p>{{ scDetail.docOwner ? scDetail.docOwner.name : "" }}</p>
                    <span>发起人</span>
                </div>
                <el-scrollbar class="person-scrollbar overflow-x-hidden">
                    <ul class="person-list">
                        <li v-for="item in scDetail.docAssociate" :key="item.id" class="person-item">
                            <img :src="item.avatar" alt />
                            <p>{{ item.name }}</p>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
            <span v-if="editType != 'EDIT_NO'" slot="footer" class="dialog-footer">
                <el-select
                    v-if="editType == 'EDIT_NOTIFY' || editType == 'EDIT_ALL'"
                    v-model="timeRangeArr"
                    placeholder="请选择(可多选)"
                    size="small"
                    multiple
                    collapse-tags
                    @change="selectTimeRange"
                >
                    <el-option
                        v-for="item in remindRangArr"
                        :key="item.time"
                        :label="item.label"
                        :value="item.range"
                    ></el-option>
                </el-select>
                <el-button
                    v-if="editType == 'EDIT_ALL'"
                    size="small"
                    class="edit-btn"
                    type="primary"
                    @click="openScheduleDetail"
                    >编辑</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        scDetail: {
            type: Object || String,
            default: () => {},
        },
        editType: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            dialogVisible: true,
            remindRangArr: [
                {
                    label: "开始前10分钟提醒",
                    range: "10-MINUTE",
                },
                {
                    label: "开始前30分钟提醒",
                    range: "30-MINUTE",
                },
                {
                    label: "开始前2个小时提醒",
                    range: "2-HOUR",
                },
                {
                    label: "开始前1天提醒",
                    range: "1-DAY",
                },
            ],
            timeRangeArr: "",
        };
    },
    watch: {
        scDetail(newVal) {
            if (newVal.quickNotify.length > 0) {
                this.timeRangeArr = [];
                newVal.quickNotify.forEach((el) => {
                    this.timeRangeArr.push(`${el.fdBeforeTime}-${el.fdTimeUnit}`);
                });
            }
        },
    },
    methods: {
        /**
         * 关闭
         */
        handleClose() {
            this.$emit("handleClose");
        },
        /**
         * 打开详情
         */
        openScheduleDetail() {
            this.$emit("openScheduleDetail");
        },
        /**
         * 设置提醒范围
         */
        selectTimeRange(arr) {
            console.log(arr);
            let timeRemindArr = [];
            arr.forEach((el) => {
                let splitEl = el.split("-");
                timeRemindArr.push({
                    fdBeforeTime: splitEl[0],
                    fdTimeUnit: splitEl[1],
                });
            });
            this.$axios
                .post("/schedule/management/updateNotice", {
                    id: this.scDetail.id,
                    notifys: timeRemindArr,
                })
                .then(() => {
                    this.$message.success("设置成功!");
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.descri {
    font-size: 16px;
    margin-bottom: 15px;
    > span {
        display: inline-block;
        color: #999;
        margin-right: 10px;
    }
    p {
        text-indent: 28px;
        padding: 5px 0;
    }
}
.person-scrollbar {
    height: 200px;
}
.person-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
}
.person-item,
.creator {
    margin-right: 40px;
    &:nth-child(6n) {
        margin-right: 0;
    }
    img {
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #eaeaf5 !important;
        border-radius: 50%;
    }
    p,
    span {
        font-size: 12px;
        text-align: center;
    }
    span {
        color: #999;
    }
}
.person-box {
    display: flex;
    .creator {
        flex-shrink: 0;
    }
    .person-item {
        width: 48px;
        margin-bottom: 10px;
        text-align: center;
    }
}
</style>
<style lang="scss">
.schedule-detail-box {
    .el-dialog__header {
        background: #f1f1f1;
        // height: 44px;
        padding: 10px 20px;
        span {
            color: $primary;
            font-size: 16px;
        }
        .el-icon-close {
            position: relative;
            top: -5px;
        }
    }
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-dialog__footer {
        padding: 10px 32px 32px;
    }
    .el-select {
        width: 220px;
    }
    .el-button {
        width: 88px !important;
        background: #fff;
        color: $primary !important;
        border: 1px solid #cdcfd4;
        margin-left: 14px;
        &:hover {
            background: #f0f7f5;
            border-color: $primary;
        }
    }
}
</style>
